import { DeliveryOptionsEnum, DeliveryPromiseResponseObject } from './DeliveryPromise';
import { FetchStatus } from './enums/RequestEnums';
import { ProductPrices } from './product-detail/ProductPriceTypes';

export type ProductBundle = {
  bundleId: number;
  bundleSlots: Array<ProductBundleSlot>;
  colourCode: string;
  colourId: number;
  description?: string;
  hoverImage?: string;
  image: string;
  prices: ProductPrices;
  productCode: string;
  productId: number;
  sizes: Array<ProductBundleSize>;
  swatch: string;
  selectedTab?: string | null;
  isMonetateBundle?: boolean; // SEPARATE type?
  calculations?: {
    status: FetchStatus;
    error?: Error;
    data: ProductBundleCalculationResponse;
  };
};

export type ProductBundleSlot = {
  bundleChildren: Array<ProductBundleChild>;
  slotNumber: number;
  isSelected?: boolean;
  displayedProduct?: ProductBundleDisplayedProduct;
};

export type ProductBundleSize = {
  active?: boolean;
  availability?: number;
  code: string;
  commercialSize?: string | null;
  commercialSizeDefault?: string | null;
  commercialSizePrefix?: string | null;
  commercialSizeSuffix?: string | null;
  fulfillmentCopy?: Record<string, string> | null;
  fullCommercialSize?: string | null;
  historicAvailable?: boolean;
  internalSizePrefix?: string | null;
  internalSizeSuffix?: string | null;
  order: number;
  originalSize?: string;
  price?: ProductBundleDiscount;
  prices?: ProductPrices;
  sku: string;
  storeSourceExcluded?: boolean;
};

export type ProductBundleChild = {
  alternativeNumber?: number;
  alternatives?: Array<ProductBundleChild>;
  availability: number;
  brand: string;
  brandId: number;
  colourId: number | null;
  colours: Array<ProductBundleChildColor>;
  currency: string;
  featureValueGenderId?: number | null;
  genderCode: string;
  productCode: string;
  productId: number;
  productRating?: number | null;
  productReviews?: number | null;
  seoUrl: string;
  slotNumber?: number;
  title: string;
  type: string;
};

export type ProductBundleChildColor = {
  alwaysVisible: boolean;
  availability: number;
  bundleDiscountPresent: boolean;
  bundleId: number;
  colourCode: string;
  colourId: number;
  description: string;
  extendedRange: boolean;
  hasDifferentPrices: boolean | null;
  hasDiscount: boolean;
  hoverImage?: string;
  image: string;
  markdown: boolean;
  price: ProductBundleDiscount;
  prices: ProductPrices;
  promoDiscountPresent: boolean;
  sizes: Array<ProductBundleSize>;
  sortOrder: number;
  swatch: string;
};

export type ProductBundleDiscount = {
  discountAmount: number;
  discountPercentage: number;
};

export type ProductBundleDisplayedProduct = {
  productCode: ProductBundleChild['productCode'];
  productId: ProductBundleChild['productId'];
  colourId: ProductBundleChild['colourId'];
  skuId?: ProductBundleSize['sku'];
};

export type ProductBundleCalculationResponse = {
  bundleCalculationPrice: BundleCalculationPrice;
  bundleCalculationPromise: DeliveryPromiseResponseObject | null;
};

export type BundleCalculationPrice = {
  bundleChildrenDiscountPct: number;
  totalPrices: ProductPrices;
  totalDiscountPercentage: number;
  totalDiscountAmount: number;
};

export type ProductPromise = {
  skuId: number;
  productId: number;
  hasStock: boolean;
  stockLocation: string;
  messages: Record<DeliveryOptionsEnum, string>;
  deliveryDateFrom: string;
  deliveryDateTo: string;
  nextDayDeliverable: boolean;
};
